module.exports = __webpack_public_path__ + "static/coastal_breeze-036481918bed17075df05e5d93f5fb7f.jpg";